import React, { useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useDispatch, useSelector } from "react-redux";
import Input from "../../../../../inputs/inputs";
import Button from "../../../../../buttons/buttons";
import CLOSE from "../../../../../../assets/images/icons/close.svg";
import { getOutletFromCookies } from "../../../../../../utils/Auth";
import foodType from "../../../../../../redux/food/foodTypes";
import {
  searchFoodAction,
  getAFoodAction,
} from "../../../../../../redux/food/foodActions";
import AddPackageSkeleton from "../../../../../skeleton/addPackage";

export default function AddOutletOrderItemModal({
  submitted,
  data,
  setData,
  setDisplayData,
}) {
  const dispatch = useDispatch();
  const outlet = getOutletFromCookies();
  let foodReducer = useSelector((state) => state.food);
  let searchFood = foodReducer.search;
  let { singleFood } = useSelector((state) => state.food);
  let food_selector = useSelector((state) => state.food);
  let food_searching = food_selector?.searching;

  const [errorMsg, setErrorMsg] = useState();
  const [display, setDisplay] = useState({});
  const [attributeFields, setAttributeFields] = useState([
    { attribute_id: "", quantity: 1 },
  ]);

  const [itemData, setItemData] = useState({
    product_outlet_type: "restaurant",
    product_outlet_name: outlet?.restaurant_name,
    product_outlet_id: outlet?.id,
    product_name: "",
    product_id: "",
    quantity: "",
  });
  const { product_id, product_outlet_id, product_name } = itemData;
  const [open, setOpen] = useState(false);
  const { business_id, restaurant_id, order_items } = data;

  function closeModalTwo() {
    setOpen(false);
  }
  function openModalTwo() {
    setOpen(true);
  }

  const handleSearchFood = (event) => {
    event.preventDefault();
    const { value } = event.target;
    setItemData((itemData) => ({
      ...itemData,
      product_name: value,
    }));
    if (value.length >= 3 && restaurant_id && business_id) {
      dispatch(
        searchFoodAction({
          search: value,
          restaurant_id: restaurant_id,
          business_id: business_id,
        })
      );
    } else if (value.length <= 3) {
      dispatch({
        type: foodType["SEARCH_FOOD"],
        payLoad: [],
      });
    }
  };

  function selectFood(food) {
    setData((data) => ({
      ...data,
      food_name: food.food_name,
    }));

    setDisplay((display) => ({
      ...display,
      quantity: "1",
      food_name: food.food_name,
      food_amount: food?.food_amount,
    }));
    var mydiv = document.getElementById(food.id);
    if (food.id) {
      mydiv.style.borderColor = "border-[#D14522]";
    }

    setItemData({
      ...itemData,
      product_outlet_type: "restaurant",
      product_outlet_id: food.restaurant_id,
      product_id: food.id,
      quantity: "1",
      product_name: food.food_name,
    });

    dispatch({
      type: foodType["SEARCH_FOOD"],
      payLoad: [],
    });

    if (food?.food_attributes) {
      dispatch(getAFoodAction(food?.id));
    }
  }

  const handleFormChange = (index, event) => {
    let data = [...attributeFields];
    data[index][event.target.name] = event.target.value;
    setAttributeFields(data);
  };

  const addAttributeFields = () => {
    let newfield = { attribute_id: "", quantity: "" };
    setAttributeFields([...attributeFields, newfield]);
  };

  const handleSubmit = () => {
    //Check if a restaurant and a food has been chosen if yes
    //begin the process to add chosen items to the parent array
    //else show an error to prompt user to add item

    if ((product_id, product_outlet_id)) {
      setErrorMsg(false);
      let newInput;

      function removeEmptyAttributes(attr) {
        return attr.filter((obj) => obj.attribute_id !== "");
      }
      const filteredAttr = removeEmptyAttributes(attributeFields);
      newInput = {
        ...itemData,
        attributes: filteredAttr,
      };

      if (product_id !== "") {
        order_items?.push(newInput);
      }
      setData((data) => ({
        ...data,
        order_items: order_items,
      }));

      //Generate the displayed attributes that include name and price to be set
      //to the display arr and displayed for uses to see
      let foodAttr = singleFood?.attributes?.map((e, i) => {
        let temp = attributeFields.find(
          (element) => Number(element.attribute_id) === Number(e.id)
        );
        if (temp) {
          temp.name = e.name;
          temp.amount = e.amount;
        }
        return temp;
      });

      setDisplayData((displayData) => [
        ...displayData,
        { ...display, attributes: attributeFields ? foodAttr : [] },
      ]);
      setItemData({
        product_outlet_type: "restaurant",
        product_outlet_id: "",
        product_id: "",
        quantity: "1",
        attributes: [],
        food_name: "",
        food_amount: "",
      });
      setAttributeFields([{ attribute_id: "", quantity: "" }]);
      dispatch({ type: foodType["SINGLE_FOOD"], payLoad: [] });
      closeModalTwo();
    } else {
      setErrorMsg(true);
    }
  };

  return (
    <div className="Coupon" data-test="couponModal">
      <div className=" flex justify-center text-center">
        <button className="text-primary" onClick={openModalTwo}>
          Add New Item +
        </button>
      </div>

      <Transition appear show={open}>
        <Dialog as="div" className="relative z-10" onClose={closeModalTwo}>
          <Transition.Child
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-center sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className=" bg-white w-[380px] text-left sm:w-[630px] p-4 sm:p-6">
                  <div>
                    <div className=" sm:block absolute top-3 right-2 pt-4 pr-4">
                      <button
                        type="button"
                        className="bg-[#ffeae5] rounded-sm p-1 sm:p-3 "
                        onClick={closeModalTwo}
                      >
                        <span className="sr-only">Close</span>
                        <img
                          src={CLOSE}
                          alt="close"
                          className=" w-3 h-3 sm:w-4 sm:h-4"
                        />
                      </button>
                    </div>

                    <div className="pb-5 text-left sm:mt-2 sm:text-left border-b border-[#E4E4F3]">
                      <Dialog.Title
                        as="p"
                        className="text-base font-meduim text-gray-500 "
                      >
                        Add New Item
                      </Dialog.Title>
                    </div>
                  </div>
                  <form className="py-5 mt-4 px-5">
                    <div className="mt-2 relative">
                      <label className="block text-sm font-medium text-[#151515]">
                        Food Items
                      </label>
                      <input
                        type={"search"}
                        name={"product_id"}
                        htmlFor={"product_id"}
                        onChange={handleSearchFood}
                        value={product_name}
                        autoComplete="off"
                        className={
                          "mt-2 block pl-3 pr-10 w-full text-base bg-gray-100 focus:ring-2 focus:ring-red-600 focus:border-red-600 focus:outline-none sm:text-sm h-[40px] px-4 py-2 mb-4 border border-gray-300 "
                        }
                        placeholder={"Search Food Item"}
                      />
                      {(submitted || errorMsg) && !product_id && (
                        <div className="text-primary text-xs -mt-4 mb-3">
                          Food is required
                        </div>
                      )}
                      {food_searching ? (
                        <div className="absolute w-full bg-white shadow z-10 top-[68px]">
                          <div className="p-3">
                            <AddPackageSkeleton />
                          </div>
                        </div>
                      ) : (
                        searchFood &&
                        Array.isArray(searchFood) && (
                          <div className="absolute w-full bg-white shadow top-[68px] z-10">
                            {searchFood?.map((food, index) => (
                              <div
                                className="px-3 py-2 border border-primary mb-2"
                                id={food.id}
                                key={index}
                                onClick={() => selectFood(food)}
                              >
                                <div className="grid-cols-2">
                                  <div className="col-span-1">
                                    <h6>Name: {food.food_name}</h6>
                                  </div>
                                  <div className="col-span-1">
                                    <h6>
                                      Category: {food.food_categories?.[0]}
                                    </h6>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )
                      )}
                    </div>

                    <p className="text-sm mb-5 -mt-2">
                      Search and add a customers food items, only food items
                      registered under{" "}
                      <span className="text-primary">
                        {outlet?.restaurant_name ?? "Selected Restaurant"}
                      </span>{" "}
                      will show here.
                    </p>
                    {singleFood?.attributes?.length > 0 && (
                      <>
                        {attributeFields.map((input, index) => (
                          <div className="grid grid-cols-2 gap-8" key={index}>
                            <Input.Select
                              title={"Attribute"}
                              name="attribute_id"
                              id="attribute_id"
                              value={input.attribute_id}
                              onChange={(event) =>
                                handleFormChange(index, event)
                              }
                              className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
                            >
                              <option>Select attribute</option>
                              {singleFood?.attributes?.map((item, index) => (
                                <option key={index} value={item.id}>
                                  {item.name}
                                </option>
                              ))}
                            </Input.Select>
                            <Input.Number
                              title={"Quantity"}
                              name="quantity"
                              id="quantity"
                              className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
                              placeholder="Enter quantity"
                              defaultValue={1}
                              min={1}
                              value={input.quantity}
                              onChange={(event) =>
                                handleFormChange(index, event)
                              }
                            />
                          </div>
                        ))}

                        {singleFood?.attributes?.length > 1 && (
                          <div className="w-full flex justify-end">
                            <button
                              type="button"
                              onClick={addAttributeFields}
                              className="text-[#CE2600B2]"
                            >
                              Add more +
                            </button>
                          </div>
                        )}
                      </>
                    )}
                  </form>

                  <div className="py-8 max-w-sm mx-auto flex justify-center text-center">
                    <Button.Primary
                      title={"Add Item"}
                      className="px-4 rounded-sm"
                      onClick={handleSubmit}
                    />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
}
